import { useQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./StoreConfig.gql";
import { useDispatch } from "react-redux";
import { saveConfigData } from "../../features/HomePage/HomePageSlice";

export const useStoreConfig = () => {
  const dispatch = useDispatch();
  const { getStoreConfig } = DEFAULT_OPERATIONS;
  const { data: StoreConfigData } = useQuery(getStoreConfig, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    context: { fetchOptions: { method: "GET" } },
    onCompleted: (data) => {
      if (data?.storeConfig) {
        dispatch(saveConfigData(data?.storeConfig));
      }
    },
  });

  return {
    StoreConfigData: StoreConfigData && StoreConfigData.storeConfig,
  };
};
